import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-emoji-list',
  templateUrl: './emoji-list.component.html',
  styleUrls: ['./emoji-list.component.css']
})
export class EmojiListComponent {
  @Output() emojiSelected = new EventEmitter<string>();

  emojis: string[] = [
    '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚',
    '😋', '😜', '😝', '😛', '🤑', '🤗', '🤭', '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄', '😬', '🤥', '😌',
    '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕', '🤢', '🤮', '🤧', '🥵', '🥶', '🥴', '😵', '🤯', '🤠', '🥳', '😎', '🤓', '🧐',
    '😕', '😟', '🙁', '☹️', '😮', '😯', '😲', '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞',
    '😓', '😩', '😫', '😤', '😡', '😠', '🤬', '😈', '👿', '💀', '☠️', '💩', '🤡', '👹', '👺', '👻', '👽', '👾', '🤖', '😺',
    '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '🙈', '🙉', '🙊', '💋', '💌', '💘', '💝', '💖', '💗', '💓', '💞', '💕',
    '💟', '❣️', '💔', '❤️', '🧡', '💛', '💚', '💙', '💜', '🤎', '🖤', '🤍', '💯', '💢', '💥', '💫', '💦', '💨', '🕳️', '💣',
    '💬', '👁️‍🗨️', '🗨️', '🗯️', '💭', '💤', '👋', '🤚', '🖐️', '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙',
    '👈', '👉', '👆', '🖕', '👇', '☝️', '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅',
    '🤳', '💪', '🦾', '🦿', '🦵', '🦶', '👂', '🦻', '👃', '🧠', '🦷', '🦴', '👀', '👁️', '👅', '👄', '🫀', '🫁', '🧑‍🦰',
    '👨‍🦰', '👩‍🦰', '🧑‍🦱', '👨‍🦱', '👩‍🦱', '🧑‍🦳', '👨‍🦳', '👩‍🦳', '🧑‍🦲', '👨‍🦲', '👩‍🦲', '👶', '🧒', '👦', '👧',
    '🧑', '👱', '👨', '🧔', '👩', '👱‍♀️', '👱‍♂️', '🧓', '👴', '👵', '🙍', '🙍‍♂️', '🙍‍♀️', '🙎', '🙎‍♂️', '🙎‍♀️', '🙅',
    '🙅‍♂️', '🙅‍♀️', '🙆', '🙆‍♂️', '🙆‍♀️', '💁', '💁‍♂️', '💁‍♀️', '🙋', '🙋‍♂️', '🙋‍♀️', '🧏', '🧏‍♂️', '🧏‍♀️', '🙇',
    '🙇‍♂️', '🙇‍♀️', '🤦', '🤦‍♂️', '🤦‍♀️', '🤷', '🤷‍♂️', '🤷‍♀️', '👨‍⚕️', '👩‍⚕️', '👨‍🎓', '👩‍🎓', '👨‍🏫', '👩‍🏫',
    '👨‍⚖️', '👩‍⚖️', '👨‍🌾', '👩‍🌾', '👨‍🍳', '👩‍🍳', '👨‍🔧', '👩‍🔧', '👨‍🏭', '👩‍🏭', '👨‍💼', '👩‍💼', '👨‍🔬', '👩‍🔬',
    '👨‍💻', '👩‍💻', '👨‍🎤', '👩‍🎤', '👨‍🎨', '👩‍🎨', '👨‍✈️', '👩‍✈️', '👨‍🚀', '👩‍🚀', '👨‍🚒', '👩‍🚒', '👮', '👮‍♂️',
    '👮‍♀️', '🕵️', '🕵️‍♂️', '🕵️‍♀️', '💂', '💂‍♂️', '💂‍♀️', '👷', '👷‍♂️', '👷‍♀️', '🤴', '👸', '👳', '👳‍♂️', '👳‍♀️',
    '👲', '🧕', '🤵', '🤵‍♂️', '🤵‍♀️', '👰', '👰‍♂️', '👰‍♀️', '🤰', '🤱', '👩‍🍼', '👨‍🍼', '🧑‍🍼', '👼', '🎅', '🤶',
    '🧑‍🎄', '🦸', '🦸‍♂️', '🦸‍♀️', '🦹', '🦹‍♂️', '🦹‍♀️', '🧙', '🧙‍♂️', '🧙‍♀️', '🧚', '🧚‍♂️', '🧚‍♀️', '🧛', '🧛‍♂️',
    '🧛‍♀️', '🧜', '🧜‍♂️', '🧜‍♀️', '🧝', '🧝‍♂️', '🧝‍♀️', '🧞', '🧞‍♂️', '🧞‍♀️', '🧟', '🧟‍♂️', '🧟‍♀️', '🧌', '💆',
    '💆‍♂️', '💆‍♀️', '💇', '💇‍♂️', '💇‍♀️', '🚶', '🚶‍♂️', '🚶‍♀️', '🧍', '🧍‍♂️', '🧍‍♀️', '🧎', '🧎‍♂️', '🧎‍♀️', '🧑‍🦯',
    '👨‍🦯', '👩‍🦯', '🧑‍🦼', '👨‍🦼', '👩‍🦼', '🧑‍🦽', '👨‍🦽', '👩‍🦽', '🏃', '🏃‍♂️', '🏃‍♀️', '💃', '🕺', '🕴️', '👯',
    '👯‍♂️', '👯‍♀️', '🧖', '🧖‍♂️', '🧖‍♀️', '🧗', '🧗‍♂️', '🧗‍♀️', '🤺', '🏇', '⛷️', '🏂', '🏌️', '🏌️‍♂️', '🏌️‍♀️',
    '🏄', '🏄‍♂️', '🏄‍♀️', '🚣', '🚣‍♂️', '🚣‍♀️', '🏊', '🏊‍♂️', '🏊‍♀️', '⛹️', '⛹️‍♂️', '⛹️‍♀️', '🏋️', '🏋️‍♂️', '🏋️‍♀️',
    '🚴', '🚴‍♂️', '🚴‍♀️', '🚵', '🚵‍♂️', '🚵‍♀️', '🤸', '🤸‍♂️', '🤸‍♀️', '🤼', '🤼‍♂️', '🤼‍♀️', '🤽', '🤽‍♂️', '🤽‍♀️',
    '🤾', '🤾‍♂️', '🤾‍♀️', '🤹', '🤹‍♂️', '🤹‍♀️', '🧘', '🧘‍♂️', '🧘‍♀️', '🛀', '🛌', '🧑‍🤝‍🧑', '👭', '👫', '👬',
    '💏', '👩‍❤️‍💋‍👨', '👩‍❤️‍💋‍👩', '👨‍❤️‍💋‍👨', '💑', '👩‍❤️‍👨', '👩‍❤️‍👩', '👨‍❤️‍👨', '👪', '👨‍👩‍👦', '👨‍👩‍👧',
    '👨‍👩‍👧‍👦', '👨‍👩‍👦‍👦', '👨‍👩‍👧‍👧', '👨‍👨‍👦', '👨‍👨‍👧', '👨‍👨‍👧‍👦', '👨‍👨‍👦‍👦', '👨‍👨‍👧‍👧', '👩‍👩‍👦',
    '👩‍👩‍👧', '👩‍👩‍👧‍👦', '👩‍👩‍👦‍👦', '👩‍👩‍👧‍👧', '👨‍👦', '👨‍👦‍👦', '👨‍👧', '👨‍👧‍👦', '👨‍👧‍👧', '👩‍👦', '👩‍👦‍👦',
    '👩‍👧', '👩‍👧‍👦', '👩‍👧‍👧', '🗣️', '👤', '👥', '🫂', '👣', '🧳', '🌂', '☂️', '🧵', '🧶', '👓', '🕶️', '🥽', '🥼',
    '🦺', '👔', '👕', '👖', '🧣', '🧤', '🧥', '🧦', '👗', '👘', '🥻', '🩱', '🩲', '🩳', '👙', '👚', '👛', '👜', '👝',
    '🎒', '👞', '👟', '🥾', '🥿', '👠', '👡', '🩰', '👢', '👑', '👒', '🎩', '🎓', '🧢', '🪖', '⛑️', '💄', '💍', '💼',
    '🏠', '🏡', '🏢', '🏣', '🏤', '🏥', '🏦', '🏨', '🏩', '🏪', '🏫', '🏬', '🏭', '🏯', '🏰', '💒', '🗼', '🗽', '⛪', '🕌',
    '🕍', '🕋', '⛩️', '🛤️', '🛣️', '🗾', '🎑', '🏞️', '🌅', '🌄', '🌠', '🎇', '🎆', '🌇', '🌆', '🏙️', '🌃', '🌌', '🌉', '🌁',
    '⌚', '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '💽', '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥', '📽️', '🎞️',
    '📞', '☎️', '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳', '📡', '🔋', '🔌', '💡', '🔦',
    '🕯️', '🪔', '💰', '💴', '💵', '💶', '💷', '💸', '💳', '🧾', '💹', '✉️', '📧', '📨', '📩', '📤', '📥', '📦', '📫', '📪'

  ];


  emojiDictionary: { [key: string]: string[] } = {
    '😀': ['grinning face', 'grinsendes gesicht'],
    '😃': ['grinning face with big eyes', 'grinsendes gesicht mit großen augen'],
    '😄': ['grinning face with smiling eyes', 'grinsendes gesicht mit lächelnden augen'],
    '😁': ['beaming face with smiling eyes', 'strahlendes gesicht mit lächelnden augen'],
    '😆': ['grinning squinting face', 'grinsendes gesicht mit zusammengekniffenen augen'],
    '😅': ['grinning face with sweat', 'grinsendes gesicht mit schweiß'],
    '😂': ['face with tears of joy', 'gesicht mit freudentränen'],
    '🤣': ['rolling on the floor laughing', 'sich vor lachen auf dem boden wälzen'],
    '😊': ['smiling face with smiling eyes', 'lächelndes gesicht mit lächelnden augen'],
    '😇': ['smiling face with halo', 'lächelndes gesicht mit heiligenschein'],
    '🙂': ['slightly smiling face', 'leicht lächelndes gesicht'],
    '🙃': ['upside-down face', 'kopfüber gesicht'],
    '😉': ['winking face', 'zwinkerndes gesicht'],
    '😌': ['relieved face', 'erleichtertes gesicht'],
    '😍': ['smiling face with heart-eyes', 'lächelndes gesicht mit herzförmigen augen'],
    '🥰': ['smiling face with hearts', 'lächelndes gesicht mit herzen'],
    '😘': ['face blowing a kiss', 'küssendes gesicht'],
    '😗': ['kissing face', 'küssendes gesicht'],
    '😙': ['kissing face with smiling eyes', 'küssendes gesicht mit lächelnden augen'],
    '😚': ['kissing face with closed eyes', 'küssendes gesicht mit geschlossenen augen'],
    '😋': ['face savoring food', 'gesicht genießt essen'],
    '😜': ['winking face with tongue', 'zwinkerndes gesicht mit zunge'],
    '😝': ['squinting face with tongue', 'gesicht mit zusammengekniffenen augen und zunge'],
    '😛': ['face with tongue', 'gesicht mit zunge'],
    '🤑': ['money-mouth face', 'geldmund-gesicht'],
    '🤗': ['hugging face', 'umarmendes gesicht'],
    '🤭': ['face with hand over mouth', 'gesicht mit hand über dem mund'],
    '🤫': ['shushing face', 'still haltendes gesicht'],
    '🤔': ['thinking face', 'nachdenkliches gesicht'],
    '🤐': ['zipper-mouth face', 'reißverschluss-mund-gesicht'],
    '🤨': ['face with raised eyebrow', 'gesicht mit erhobener augenbraue'],
    '😐': ['neutral face', 'neutrales gesicht'],
    '😑': ['expressionless face', 'ausdrucksloses gesicht'],
    '😶': ['face without mouth', 'gesicht ohne mund'],
    '😏': ['smirking face', 'schmunzelndes gesicht'],
    '😒': ['unamused face', 'nicht amüsiertes gesicht'],
    '🙄': ['face with rolling eyes', 'gesicht mit rollenden augen'],
    '😬': ['grimacing face', 'grimassierendes gesicht'],
    '🤥': ['lying face', 'lügendes gesicht'],
    '😔': ['pensive face', 'nachdenkliches gesicht'],
    '😪': ['sleepy face', 'müdes gesicht'],
    '🤤': ['drooling face', 'sabberndes gesicht'],
    '😴': ['sleeping face', 'schlafendes gesicht'],
    '😷': ['face with medical mask', 'gesicht mit medizinischer maske'],
    '🤒': ['face with thermometer', 'gesicht mit thermometer'],
    '🤕': ['face with head-bandage', 'gesicht mit kopfverband'],
    '🤢': ['nauseated face', 'übelkeit'],
    '🤮': ['face vomiting', 'erbrechendes gesicht'],
    '🤧': ['sneezing face', 'niesendes gesicht'],
    '🥵': ['hot face', 'heißes gesicht'],
    '🥶': ['cold face', 'kaltes gesicht'],
    '🥴': ['woozy face', 'benommenes gesicht'],
    '😵': ['dizzy face', 'schwindeliges gesicht'],
    '🤯': ['exploding head', 'explodierender kopf'],
    '🤠': ['cowboy hat face', 'gesicht mit cowboyhut'],
    '🥳': ['partying face', 'feierndes gesicht'],
    '😎': ['smiling face with sunglasses', 'lächelndes gesicht mit sonnenbrille'],
    '🤓': ['nerd face', 'nerd-gesicht'],
    '🧐': ['face with monocle', 'gesicht mit monokel'],
    '😕': ['confused face', 'verwirrtes gesicht'],
    '😟': ['worried face', 'besorgtes gesicht'],
    '🙁': ['slightly frowning face', 'leicht schmollendes gesicht'],
    '☹️': ['frowning face', 'schmollendes gesicht'],
    '😮': ['face with open mouth', 'gesicht mit offenem mund'],
    '😯': ['hushed face', 'stilles gesicht'],
    '😲': ['astonished face', 'erstauntes gesicht'],
    '😳': ['flushed face', 'errötetes gesicht'],
    '🥺': ['pleading face', 'flehendes gesicht'],
    '😦': ['frowning face with open mouth', 'schmollendes gesicht mit offenem mund'],
    '😧': ['anguished face', 'gequältes gesicht'],
    '😨': ['fearful face', 'ängstliches gesicht'],
    '😰': ['anxious face with sweat', 'ängstliches gesicht mit schweiß'],
    '😥': ['sad but relieved face', 'trauriges aber erleichtertes gesicht'],
    '😢': ['crying face', 'weinendes gesicht'],
    '😭': ['loudly crying face', 'laut weinendes gesicht'],
    '😱': ['face screaming in fear', 'gesicht schreit vor angst'],
    '😖': ['confounded face', 'verzweifeltes gesicht'],
    '😣': ['persevering face', 'durchhaltendes gesicht'],
    '😞': ['disappointed face', 'enttäuschtes gesicht'],
    '😓': ['downcast face with sweat', 'niedergeschlagenes gesicht mit schweiß'],
    '😩': ['weary face', 'müdes gesicht'],
    '😫': ['tired face', 'müdes gesicht'],
    '😤': ['face with steam from nose', 'gesicht mit dampf aus der nase'],
    '😡': ['pouting face', 'saueres gesicht'],
    '😠': ['angry face', 'wütendes gesicht'],
    '🤬': ['face with symbols on mouth', 'gesicht mit symbolen auf dem mund'],
    '😈': ['smiling face with horns', 'lächelndes gesicht mit hörnern'],
    '👿': ['angry face with horns', 'wütendes gesicht mit hörnern'],
    '💀': ['skull', 'schädel'],
    '☠️': ['skull and crossbones', 'schädel und gekreuzte knochen'],
    '💩': ['pile of poo', 'haufen kot'],
    '🤡': ['clown face', 'clown-gesicht'],
    '👹': ['ogre', 'oger'],
    '👺': ['goblin', 'kobold'],
    '👻': ['ghost', 'geist'],
    '👽': ['alien', 'außerirdischer'],
    '👾': ['alien monster', 'alienmonster'],
    '🤖': ['robot', 'roboter'],
    '😺': ['grinning cat', 'grinsende katze'],
    '😸': ['grinning cat with smiling eyes', 'grinsende katze mit lächelnden augen'],
    '😹': ['cat with tears of joy', 'katze mit freudentränen'],
    '😻': ['smiling cat with heart-eyes', 'lächelnde katze mit herzaugen'],
    '😼': ['cat with wry smile', 'katze mit schiefem lächeln'],
    '😽': ['kissing cat', 'küssende katze'],
    '🙀': ['weary cat', 'müde katze'],
    '😿': ['crying cat', 'weinende katze'],
    '😾': ['pouting cat', 'schmollende katze'],
    '🙈': ['see-no-evil monkey', 'nicht sehen affe'],
    '🙉': ['hear-no-evil monkey', 'nicht hören affe'],
    '🙊': ['speak-no-evil monkey', 'nicht sprechen affe'],
    '💋': ['kiss mark', 'kussabdruck'],
    '💌': ['love letter', 'liebesbrief'],
    '💘': ['heart with arrow', 'herz mit pfeil'],
    '💝': ['heart with ribbon', 'herz mit schleife'],
    '💖': ['sparkling heart', 'funkelndes herz'],
    '💗': ['growing heart', 'wachsendes herz'],
    '💓': ['beating heart', 'schlagendes herz'],
    '💞': ['revolving hearts', 'rotierende herzen'],
    '💕': ['two hearts', 'zwei herzen'],
    '💟': ['heart decoration', 'herzdekoration'],
    '❣️': ['heart exclamation', 'herzausruf'],
    '💔': ['broken heart', 'gebrochenes herz'],
    '❤️': ['red heart', 'rotes herz'],
    '🧡': ['orange heart', 'oranges herz'],
    '💛': ['yellow heart', 'gelbes herz'],
    '💚': ['green heart', 'grünes herz'],
    '💙': ['blue heart', 'blaues herz'],
    '💜': ['purple heart', 'lila herz'],
    '🤎': ['brown heart', 'braunes herz'],
    '🖤': ['black heart', 'schwarzes herz'],
    '🤍': ['white heart', 'weißes herz'],
    '💯': ['hundred points', 'hundert punkte'],
    '💢': ['anger symbol', 'ärgersymbol'],
    '💥': ['collision', 'kollision'],
    '💫': ['dizzy', 'schwindlig'],
    '💦': ['sweat droplets', 'schweißperlen'],
    '💨': ['dashing away', 'davonstürmen'],
    '🕳️': ['hole', 'loch'],
    '💣': ['bomb', 'bombe'],
    '💬': ['speech balloon', 'sprechblase'],
    '👁️‍🗨️': ['eye in speech bubble', 'auge in sprechblase'],
    '🗨️': ['left speech bubble', 'linke sprechblase'],
    '🗯️': ['right anger bubble', 'rechte ärgerblase'],
    '💭': ['thought balloon', 'gedankenblase'],
    '💤': ['zzz', 'zzz'],
    '👋': ['waving hand', 'winkende hand'],
    '🤚': ['raised back of hand', 'gehobene handrückseite'],
    '🖐️': ['hand with fingers splayed', 'hand mit gespreizten fingern'],
    '✋': ['raised hand', 'erhobene hand'],
    '🖖': ['vulcan salute', 'vulkanischer gruß'],
    '👌': ['ok hand', 'ok-hand'],
    '🤌': ['pinched fingers', 'gekniffene finger'],
    '🤏': ['pinching hand', 'kneifende hand'],
    '✌️': ['victory hand', 'siegessymbol'],
    '🤞': ['crossed fingers', 'gekreuzte finger'],
    '🤟': ['love-you gesture', 'liebesgesten'],
    '🤘': ['sign of the horns', 'zeichen der hörner'],
    '🤙': ['call me hand', 'ruf-mich-an-hand'],
    '👈': ['backhand index pointing left', 'zeigefinger nach links'],
    '👉': ['backhand index pointing right', 'zeigefinger nach rechts'],
    '👆': ['backhand index pointing up', 'zeigefinger nach oben'],
    '🖕': ['middle finger', 'mittelfinger'],
    '👇': ['backhand index pointing down', 'zeigefinger nach unten'],
    '☝️': ['index pointing up', 'zeigefinger nach oben'],
    '👍': ['thumbs up', 'daumen hoch'],
    '👎': ['thumbs down', 'daumen runter'],
    '✊': ['raised fist', 'erhobene faust'],
    '👊': ['oncoming fist', 'kommende faust'],
    '🤛': ['left-facing fist', 'nach links gerichtete faust'],
    '🤜': ['right-facing fist', 'nach rechts gerichtete faust'],
    '👏': ['clapping hands', 'klatschende hände'],
    '🙌': ['raising hands', 'hochgehobene hände'],
    '👐': ['open hands', 'offene hände'],
    '🤲': ['palms up together', 'handflächen zusammen'],
    '🤝': ['handshake', 'handdruck'],
    '🙏': ['folded hands', 'gefaltete hände'],
    '✍️': ['writing hand', 'schreibende hand'],
    '💅': ['nail polish', 'nagellack'],
    '🤳': ['selfie', 'selfie'],
    '💪': ['flexed biceps', 'gebeugter bizeps'],
    '🦾': ['mechanical arm', 'mechanischer arm'],
    '🦿': ['mechanical leg', 'mechanisches bein'],
    '🦵': ['leg', 'bein'],
    '🦶': ['foot', 'fuß'],
    '👂': ['ear', 'ohr'],
    '🦻': ['ear with hearing aid', 'ohr mit hörgerät'],
    '👃': ['nose', 'nase'],
    '🧠': ['brain', 'gehirn'],
    '🦷': ['tooth', 'zahn'],
    '🦴': ['bone', 'knochen'],
    '👀': ['eyes', 'augen'],
    '👁️': ['eye', 'auge'],
    '👅': ['tongue', 'zunge'],
    '👄': ['mouth', 'mund'],
    '🫀': ['anatomical heart', 'anatomisches herz'],
    '🫁': ['lungs', 'lungen'],
    '🧑‍🦰': ['person: red hair', 'person: rote haare'],
    '👨‍🦰': ['man: red hair', 'mann: rote haare'],
    '👩‍🦰': ['woman: red hair', 'frau: rote haare'],
    '🧑‍🦱': ['person: curly hair', 'person: lockiges haar'],
    '👨‍🦱': ['man: curly hair', 'mann: lockiges haar'],
    '👩‍🦱': ['woman: curly hair', 'frau: lockiges haar'],
    '🧑‍🦳': ['person: white hair', 'person: weißes haar'],
    '👨‍🦳': ['man: white hair', 'mann: weißes haar'],
    '👩‍🦳': ['woman: white hair', 'frau: weißes haar'],
    '🧑‍🦲': ['person: bald', 'person: glatze'],
    '👨‍🦲': ['man: bald', 'mann: glatze'],
    '👩‍🦲': ['woman: bald', 'frau: glatze'],
    '👶': ['baby', 'baby'],
    '🧒': ['child', 'kind'],
    '👦': ['boy', 'junge'],
    '👧': ['girl', 'mädchen'],
    '🧑': ['person', 'person'],
    '👱': ['person: blond hair', 'person: blondes haar'],
    '👨': ['man', 'mann'],
    '🧔': ['man: beard', 'mann: bart'],
    '👩': ['woman', 'frau'],
    '👱‍♀️': ['woman: blond hair', 'frau: blondes haar'],
    '👱‍♂️': ['man: blond hair', 'mann: blondes haar'],
    '🧓': ['older person', 'ältere person'],
    '👴': ['old man', 'alter mann'],
    '👵': ['old woman', 'alte frau'],
    '🙍': ['person frowning', 'person stirnrunzelnd'],
    '🙍‍♂️': ['man frowning', 'mann stirnrunzelnd'],
    '🙍‍♀️': ['woman frowning', 'frau stirnrunzelnd'],
    '🙎': ['person pouting', 'person schmollend'],
    '🙎‍♂️': ['man pouting', 'mann schmollend'],
    '🙎‍♀️': ['woman pouting', 'frau schmollend'],
    '🙅': ['person gesturing no', 'person gestikuliert nein'],
    '🙅‍♂️': ['man gesturing no', 'mann gestikuliert nein'],
    '🙅‍♀️': ['woman gesturing no', 'frau gestikuliert nein'],
    '🙆': ['person gesturing ok', 'person gestikuliert ok'],
    '🙆‍♂️': ['man gesturing ok', 'mann gestikuliert ok'],
    '🙆‍♀️': ['woman gesticulating ok', 'frau gestikuliert ok'],
    '💁': ['person tipping hand', 'person kippt hand'],
    '💁‍♂️': ['man tipping hand', 'mann kippt hand'],
    '💁‍♀️': ['woman tipping hand', 'frau kippt hand'],
    '🙋': ['person raising hand', 'person hebt hand'],
    '🙋‍♂️': ['man raising hand', 'mann hebt hand'],
    '🙋‍♀️': ['woman raising hand', 'frau hebt hand'],
    '🧏': ['deaf person', 'gehörlose person'],
    '🧏‍♂️': ['deaf man', 'gehörloser mann'],
    '🧏‍♀️': ['deaf woman', 'gehörlose frau'],
    '🙇': ['person bowing', 'person verbeugt sich'],
    '🙇‍♂️': ['man bowing', 'mann verbeugt sich'],
    '🙇‍♀️': ['woman bowing', 'frau verbeugt sich'],
    '🤦': ['person facepalming', 'person fasst sich an den kopf'],
    '🤦‍♂️': ['man facepalming', 'mann fasst sich an den kopf'],
    '🤦‍♀️': ['woman facepalming', 'frau fasst sich an den kopf'],
    '🤷': ['person shrugging', 'person zuckt mit den schultern'],
    '🤷‍♂️': ['man shrugging', 'mann zuckt mit den schultern'],
    '🤷‍♀️': ['woman shrugging', 'frau zuckt mit den schultern'],
    '👨‍⚕️': ['man health worker', 'mann gesundheitsarbeiter'],
    '👩‍⚕️': ['woman health worker', 'frau gesundheitsarbeiterin'],
    '👨‍🎓': ['man student', 'mann student'],
    '👩‍🎓': ['woman student', 'frau studentin'],
    '👨‍🏫': ['man teacher', 'mann lehrer'],
    '👩‍🏫': ['woman teacher', 'frau lehrerin'],
    '👨‍⚖️': ['man judge', 'mann richter'],
    '👩‍⚖️': ['woman judge', 'frau richterin'],
    '👨‍🌾': ['man farmer', 'mann bauer'],
    '👩‍🌾': ['woman farmer', 'frau bäuerin'],
    '👨‍🍳': ['man cook', 'mann koch'],
    '👩‍🍳': ['woman cook', 'frau köchin'],
    '👨‍🔧': ['man mechanic', 'mann mechaniker'],
    '👩‍🔧': ['woman mechanic', 'frau mechanikerin'],
    '👨‍🏭': ['man factory worker', 'mann fabrikarbeiter'],
    '👩‍🏭': ['woman factory worker', 'frau fabrikarbeiterin'],
    '👨‍💼': ['man office worker', 'mann büroangestellter'],
    '👩‍💼': ['woman office worker', 'frau büroangestellte'],
    '👨‍🔬': ['man scientist', 'mann wissenschaftler'],
    '👩‍🔬': ['woman scientist', 'frau wissenschaftlerin'],
    '👨‍💻': ['man technologist', 'mann techniker'],
    '👩‍💻': ['woman technologist', 'frau technikerin'],
    '👨‍🎤': ['man singer', 'mann sänger'],
    '👩‍🎤': ['woman singer', 'frau sängerin'],
    '👨‍🎨': ['man artist', 'mann künstler'],
    '👩‍🎨': ['woman artist', 'frau künstlerin'],
    '👨‍✈️': ['man pilot', 'mann pilot'],
    '👩‍✈️': ['woman pilot', 'frau pilotin'],
    '👨‍🚀': ['man astronaut', 'mann astronaut'],
    '👩‍🚀': ['woman astronaut', 'frau astronautin'],
    '👨‍🚒': ['man firefighter', 'mann feuerwehrmann'],
    '👩‍🚒': ['woman firefighter', 'frau feuerwehrfrau'],
    '👮': ['police officer', 'polizist'],
    '👮‍♂️': ['man police officer', 'mann polizist'],
    '👮‍♀️': ['woman police officer', 'frau polizistin'],
    '🕵️': ['detective', 'detektiv'],
    '🕵️‍♂️': ['man detective', 'mann detektiv'],
    '🕵️‍♀️': ['woman detective', 'frau detektivin'],
    '💂': ['guard', 'wächter'],
    '💂‍♂️': ['man guard', 'mann wächter'],
    '💂‍♀️': ['woman guard', 'frau wächterin'],
    '👷': ['construction worker', 'bauarbeiter'],
    '👷‍♂️': ['man construction worker', 'mann bauarbeiter'],
    '👷‍♀️': ['woman construction worker', 'frau bauarbeiterin'],
    '🤴': ['prince', 'prinz'],
    '👸': ['princess', 'prinzessin'],
    '👳': ['person wearing turban', 'person mit turban'],
    '👳‍♂️': ['man wearing turban', 'mann mit turban'],
    '👳‍♀️': ['woman wearing turban', 'frau mit turban'],
    '👲': ['person with skullcap', 'person mit käppchen'],
    '🧕': ['woman with headscarf', 'frau mit kopftuch'],
    '🤵': ['person in tuxedo', 'person im smoking'],
    '🤵‍♂️': ['man in tuxedo', 'mann im smoking'],
    '🤵‍♀️': ['woman in tuxedo', 'frau im smoking'],
    '👰': ['person with veil', 'person mit schleier'],
    '👰‍♂️': ['man with veil', 'mann mit schleier'],
    '👰‍♀️': ['woman with veil', 'frau mit schleier'],
    '🤰': ['pregnant woman', 'schwangere frau'],
    '🤱': ['breast-feeding', 'stillend'],
    '👩‍🍼': ['woman feeding baby', 'frau füttert baby'],
    '👨‍🍼': ['man feeding baby', 'mann füttert baby'],
    '🧑‍🍼': ['person feeding baby', 'person füttert baby'],
    '👼': ['baby angel', 'babyengel'],
    '🎅': ['santa claus', 'weihnachtsmann'],
    '🤶': ['mrs. claus', 'frau weihnachtsmann'],
    '🧑‍🎄': ['mx claus', 'mx claus'],
    '🦸': ['superhero', 'superheld'],
    '🦸‍♂️': ['man superhero', 'mann superheld'],
    '🦸‍♀️': ['woman superhero', 'frau superheldin'],
    '🦹': ['supervillain', 'superschurke'],
    '🦹‍♂️': ['man supervillain', 'mann superschurke'],
    '🦹‍♀️': ['woman supervillain', 'frau superschurkin'],
    '🧙': ['mage', 'magier'],
    '🧙‍♂️': ['man mage', 'mann magier'],
    '🧙‍♀️': ['woman mage', 'frau magierin'],
    '🧚': ['fairy', 'fee'],
    '🧚‍♂️': ['man fairy', 'mann fee'],
    '🧚‍♀️': ['woman fairy', 'frau fee'],
    '🧛': ['vampire', 'vampir'],
    '🧛‍♂️': ['man vampire', 'mann vampir'],
    '🧛‍♀️': ['woman vampire', 'frau vampir'],
    '🧜': ['merperson', 'meerjungfrau'],
    '🧜‍♂️': ['merman', 'meerjungmann'],
    '🧜‍♀️': ['mermaid', 'meerjungfrau'],
    '🧝': ['elf', 'elf'],
    '🧝‍♂️': ['man elf', 'mann elf'],
    '🧝‍♀️': ['woman elf', 'frau elf'],
    '🧞': ['genie', 'dschinn'],
    '🧞‍♂️': ['man genie', 'mann dschinn'],
    '🧞‍♀️': ['woman genie', 'frau dschinn'],
    '🧟': ['zombie', 'zombie'],
    '🧟‍♂️': ['man zombie', 'mann zombie'],
    '🧟‍♀️': ['woman zombie', 'frau zombie'],
    '🧌': ['troll', 'troll'],
    '💆': ['person getting massage', 'person bekommt massage'],
    '💆‍♂️': ['man getting massage', 'mann bekommt massage'],
    '💆‍♀️': ['woman getting massage', 'frau bekommt massage'],
    '💇': ['person getting haircut', 'person bekommt haarschnitt'],
    '💇‍♂️': ['man getting haircut', 'mann bekommt haarschnitt'],
    '💇‍♀️': ['woman getting haircut', 'frau bekommt haarschnitt'],
    '🚶': ['person walking', 'person geht'],
    '🚶‍♂️': ['man walking', 'mann geht'],
    '🚶‍♀️': ['woman walking', 'frau geht'],
    '🧍': ['person standing', 'person steht'],
    '🧍‍♂️': ['man standing', 'mann steht'],
    '🧍‍♀️': ['woman standing', 'frau steht'],
    '🧎': ['person kneeling', 'person kniet'],
    '🧎‍♂️': ['man kneeling', 'mann kniet'],
    '🧎‍♀️': ['woman kneeling', 'frau kniet'],
    '🧑‍🦯': ['person with white cane', 'person mit weißem stock'],
    '👨‍🦯': ['man with white cane', 'mann mit weißem stock'],
    '👩‍🦯': ['woman with white cane', 'frau mit weißem stock'],
    '🧑‍🦼': ['person in motorized wheelchair', 'person im motorisierten rollstuhl'],
    '👨‍🦼': ['man in motorized wheelchair', 'mann im motorisierten rollstuhl'],
    '👩‍🦼': ['woman in motorized wheelchair', 'frau im motorisierten rollstuhl'],
    '🧑‍🦽': ['person in manual wheelchair', 'person im manuellen rollstuhl'],
    '👨‍🦽': ['man in manual wheelchair', 'mann im manuellen rollstuhl'],
    '👩‍🦽': ['woman in manual wheelchair', 'frau im manuellen rollstuhl'],
    '🏃': ['person running', 'person rennt'],
    '🏃‍♂️': ['man running', 'mann rennt'],
    '🏃‍♀️': ['woman running', 'frau rennt'],
    '💃': ['woman dancing', 'frau tanzt'],
    '🕺': ['man dancing', 'mann tanzt'],
    '🕴️': ['person in suit levitating', 'person im anzug schwebend'],
    '👯': ['people with bunny ears', 'menschen mit hasenohren'],
    '👯‍♂️': ['men with bunny ears', 'männer mit hasenohren'],
    '👯‍♀️': ['women with bunny ears', 'frauen mit hasenohren'],
    '🧖': ['person in steamy room', 'person im dampfzimmer'],
    '🧖‍♂️': ['man in steamy room', 'mann im dampfzimmer'],
    '🧖‍♀️': ['woman in steamy room', 'frau im dampfzimmer'],
    '🧗': ['person climbing', 'person klettert'],
    '🧗‍♂️': ['man climbing', 'mann klettert'],
    '🧗‍♀️': ['woman climbing', 'frau klettert'],
    '🤺': ['person fencing', 'person fechtet'],
    '🏇': ['horse racing', 'pferderennen'],
    '⛷️': ['skier', 'skifahrer'],
    '🏂': ['snowboarder', 'snowboarder'],
    '🏌️': ['person golfing', 'person spielt golf'],
    '🏌️‍♂️': ['man golfing', 'mann spielt golf'],
    '🏌️‍♀️': ['woman golfing', 'frau spielt golf'],
    '🏄': ['person surfing', 'person surft'],
    '🏄‍♂️': ['man surfing', 'mann surft'],
    '🏄‍♀️': ['woman surfing', 'frau surft'],
    '🚣': ['person rowing boat', 'person rudert boot'],
    '🚣‍♂️': ['man rowing boat', 'mann rudert boot'],
    '🚣‍♀️': ['woman rowing boat', 'frau rudert boot'],
    '🏊': ['person swimming', 'person schwimmt'],
    '🏊‍♂️': ['man swimming', 'mann schwimmt'],
    '🏊‍♀️': ['woman swimming', 'frau schwimmt'],
    '⛹️': ['person bouncing ball', 'person prellt ball'],
    '⛹️‍♂️': ['man bouncing ball', 'mann prellt ball'],
    '⛹️‍♀️': ['woman bouncing ball', 'frau prellt ball'],
    '🏋️': ['person lifting weights', 'person hebt gewichte'],
    '🏋️‍♂️': ['man lifting weights', 'mann hebt gewichte'],
    '🏋️‍♀️': ['woman lifting weights', 'frau hebt gewichte'],
    '🚴': ['person biking', 'person fährt rad'],
    '🚴‍♂️': ['man biking', 'mann fährt rad'],
    '🚴‍♀️': ['woman biking', 'frau fährt rad'],
    '🚵': ['person mountain biking', 'person fährt mountainbike'],
    '🚵‍♂️': ['man mountain biking', 'mann fährt mountainbike'],
    '🚵‍♀️': ['woman mountain biking', 'frau fährt mountainbike'],
    '🤸': ['person cartwheeling', 'person macht radschlag'],
    '🤸‍♂️': ['man cartwheeling', 'mann macht radschlag'],
    '🤸‍♀️': ['woman cartwheeling', 'frau macht radschlag'],
    '🤼': ['people wrestling', 'menschen ringen'],
    '🤼‍♂️': ['men wrestling', 'männer ringen'],
    '🤼‍♀️': ['women wrestling', 'frauen ringen'],
    '🤽': ['person playing water polo', 'person spielt wasserball'],
    '🤽‍♂️': ['man playing water polo', 'mann spielt wasserball'],
    '🤽‍♀️': ['woman playing water polo', 'frau spielt wasserball'],
    '🤾': ['person playing handball', 'person spielt handball'],
    '🤾‍♂️': ['man playing handball', 'mann spielt handball'],
    '🤾‍♀️': ['woman playing handball', 'frau spielt handball'],
    '🤹': ['person juggling', 'person jongliert'],
    '🤹‍♂️': ['man juggling', 'mann jongliert'],
    '🤹‍♀️': ['woman juggling', 'frau jongliert'],
    '🧘': ['person in lotus position', 'person im lotus-sitz'],
    '🧘‍♂️': ['man in lotus position', 'mann im lotus-sitz'],
    '🧘‍♀️': ['woman in lotus position', 'frau im lotus-sitz'],
    '🛀': ['person taking bath', 'person nimmt bad'],
    '🛌': ['person in bed', 'person im bett'],
    '🧑‍🤝‍🧑': ['people holding hands', 'menschen halten hände'],
    '👭': ['women holding hands', 'frauen halten hände'],
    '👫': ['woman and man holding hands', 'frau und mann halten hände'],
    '👬': ['men holding hands', 'männer halten hände'],
    '💏': ['kiss', 'kuss'],
    '👩‍❤️‍💋‍👨': ['kiss: woman, man', 'kuss: frau, mann'],
    '👩‍❤️‍💋‍👩': ['kiss: woman, woman', 'kuss: frau, frau'],
    '👨‍❤️‍💋‍👨': ['kiss: man, man', 'kuss: mann, mann'],
    '💑': ['couple with heart', 'paar mit herz'],
    '👩‍❤️‍👨': ['couple with heart: woman, man', 'paar mit herz: frau, mann'],
    '👩‍❤️‍👩': ['couple with heart: woman, woman', 'paar mit herz: frau, frau'],
    '👨‍❤️‍👨': ['couple with heart: man, man', 'paar mit herz: mann, mann'],
    '👪': ['family', 'familie'],
    '👨‍👩‍👦': ['family: man, woman, boy', 'familie: mann, frau, junge'],
    '👨‍👩‍👧': ['family: man, woman, girl', 'familie: mann, frau, mädchen'],
    '👨‍👩‍👧‍👦': ['family: man, woman, girl, boy', 'familie: mann, frau, mädchen, junge'],
    '👨‍👩‍👦‍👦': ['family: man, woman, boy, boy', 'familie: mann, frau, junge, junge'],
    '👨‍👩‍👧‍👧': ['family: man, woman, girl, girl', 'familie: mann, frau, mädchen, mädchen'],
    '👨‍👨‍👦': ['family: man, man, boy', 'familie: mann, mann, junge'],
    '👨‍👨‍👧': ['family: man, man, girl', 'familie: mann, mann, mädchen'],
    '👨‍👨‍👧‍👦': ['family: man, man, girl, boy', 'familie: mann, mann, mädchen, junge'],
    '👨‍👨‍👦‍👦': ['family: man, man, boy, boy', 'familie: mann, mann, junge, junge'],
    '👨‍👨‍👧‍👧': ['family: man, man, girl, girl', 'familie: mann, mann, mädchen, mädchen'],
    '👩‍👩‍👦': ['family: woman, woman, boy', 'familie: frau, frau, junge'],
    '👩‍👩‍👧': ['family: woman, woman, girl', 'familie: frau, frau, mädchen'],
    '👩‍👩‍👧‍👦': ['family: woman, woman, girl, boy', 'familie: frau, frau, mädchen, junge'],
    '👩‍👩‍👦‍👦': ['family: woman, woman, boy, boy', 'familie: frau, frau, junge, junge'],
    '👩‍👩‍👧‍👧': ['family: woman, woman, girl, girl', 'familie: frau, frau, mädchen, mädchen'],
    '👨‍👦': ['family: man, boy', 'familie: mann, junge'],
    '👨‍👦‍👦': ['family: man, boy, boy', 'familie: mann, junge, junge'],
    '👨‍👧': ['family: man, girl', 'familie: mann, mädchen'],
    '👨‍👧‍👦': ['family: man, girl, boy', 'familie: mann, mädchen, junge'],
    '👨‍👧‍👧': ['family: man, girl, girl', 'familie: mann, mädchen, mädchen'],
    '👩‍👦': ['family: woman, boy', 'familie: frau, junge'],
    '👩‍👦‍👦': ['family: woman, boy, boy', 'familie: frau, junge, junge'],
    '👩‍👧': ['family: woman, girl', 'familie: frau, mädchen'],
    '👩‍👧‍👦': ['family: woman, girl, boy', 'familie: frau, mädchen, junge'],
    '👩‍👧‍👧': ['family: woman, girl, girl', 'familie: frau, mädchen, mädchen'],
    '🗣️': ['speaking head', 'sprechender kopf'],
    '👤': ['bust in silhouette', 'büste im schattenriss'],
    '👥': ['busts in silhouette', 'büsten im schattenriss'],
    '🫂': ['people hugging', 'menschen umarmen sich'],
    '👣': ['footprints', 'fußabdrücke'],
    '🧳': ['luggage', 'gepäck'],
    '🌂': ['closed umbrella', 'geschlossener regenschirm'],
    '☂️': ['umbrella', 'regenschirm'],
    '🧵': ['thread', 'faden'],
    '🧶': ['yarn', 'garn'],
    '👓': ['glasses', 'brille'],
    '🕶️': ['sunglasses', 'sonnenbrille'],
    '🥽': ['goggles', 'schutzbrille'],
    '🥼': ['lab coat', 'laborkittel'],
    '🦺': ['safety vest', 'schutzweste'],
    '👔': ['necktie', 'krawatte'],
    '👕': ['t-shirt', 't-shirt'],
    '👖': ['jeans', 'jeans'],
    '🧣': ['scarf', 'schal'],
    '🧤': ['gloves', 'handschuhe'],
    '🧥': ['coat', 'mantel'],
    '🧦': ['socks', 'socken'],
    '👗': ['dress', 'kleid'],
    '👘': ['kimono', 'kimono'],
    '🥻': ['sari', 'sari'],
    '🩱': ['one-piece swimsuit', 'einteiliger badeanzug'],
    '🩲': ['briefs', 'slips'],
    '🩳': ['shorts', 'shorts'],
    '👙': ['bikini', 'bikini'],
    '👚': ['woman’s clothes', 'frauenkleidung'],
    '👛': ['purse', 'geldbörse'],
    '👜': ['handbag', 'handtasche'],
    '👝': ['clutch bag', 'clutch-tasche'],
    '🎒': ['backpack', 'rucksack'],
    '👞': ['man’s shoe', 'männer schuh'],
    '👟': ['running shoe', 'laufschuh'],
    '🥾': ['hiking boot', 'wanderstiefel'],
    '🥿': ['flat shoe', 'flacher schuh'],
    '👠': ['high-heeled shoe', 'hochhackiger schuh'],
    '👡': ['woman’s sandal', 'frauen sandale'],
    '🩰': ['ballet shoes', 'ballettschuhe'],
    '👢': ['woman’s boot', 'frauenstiefel'],
    '👑': ['crown', 'krone'],
    '👒': ['woman’s hat', 'frauenhut'],
    '🎩': ['top hat', 'zylinder'],
    '🎓': ['graduation cap', 'abschlusshut'],
    '🧢': ['billed cap', 'schirmmütze'],
    '🪖': ['military helmet', 'militärhelm'],
    '⛑️': ['rescue worker’s helmet', 'rettungsarbeiterhelm'],
    '💄': ['lipstick', 'lippenstift'],
    '💍': ['ring', 'ring'],
    '💼': ['briefcase', 'aktenkoffer'],
    '🏠': ['house', 'haus'],
    '🏡': ['house with garden', 'haus mit garten'],
    '🏢': ['office building', 'bürogebäude'],
    '🏣': ['japanese post office', 'japanisches postamt'],
    '🏤': ['post office', 'postamt'],
    '🏥': ['hospital', 'krankenhaus'],
    '🏦': ['bank', 'bank'],
    '🏨': ['hotel', 'hotel'],
    '🏩': ['love hotel', 'liebeshotel'],
    '🏪': ['convenience store', 'kiosk'],
    '🏫': ['school', 'schule'],
    '🏬': ['department store', 'kaufhaus'],
    '🏭': ['factory', 'fabrik'],
    '🏯': ['japanese castle', 'japanische burg'],
    '🏰': ['castle', 'burg'],
    '💒': ['wedding', 'hochzeit'],
    '🗼': ['tokyo tower', 'tokyo tower'],
    '🗽': ['statue of liberty', 'freiheitsstatue'],
    '⛪': ['church', 'kirche'],
    '🕌': ['mosque', 'moschee'],
    '🕍': ['synagogue', 'synagoge'],
    '🕋': ['kaaba', 'kaaba'],
    '⛩️': ['shinto shrine', 'shinto-schrein'],
    '🛤️': ['railway track', 'bahngleis'],
    '🛣️': ['motorway', 'autobahn'],
    '🗾': ['map of japan', 'karte von japan'],
    '🎑': ['moon viewing ceremony', 'mondbetrachtungszeremonie'],
    '🏞️': ['national park', 'nationalpark'],
    '🌅': ['sunrise', 'sonnenaufgang'],
    '🌄': ['sunrise over mountains', 'sonnenaufgang über bergen'],
    '🌠': ['shooting star', 'schnuppe'],
    '🎇': ['sparkler', 'wunderkerze'],
    '🎆': ['fireworks', 'feuerwerk'],
    '🌇': ['sunset', 'sonnenuntergang'],
    '🌆': ['cityscape at dusk', 'stadtansicht in der dämmerung'],
    '🏙️': ['cityscape', 'stadtansicht'],
    '🌃': ['night with stars', 'nacht mit sternen'],
    '🌌': ['milky way', 'milchstraße'],
    '🌉': ['bridge at night', 'brücke bei nacht'],
    '🌁': ['foggy', 'neblig'],
    '⌚': ['watch', 'uhr'],
    '📱': ['mobile phone', 'handy'],
    '📲': ['mobile phone with arrow', 'handy mit pfeil'],
    '💻': ['laptop', 'laptop'],
    '⌨️': ['keyboard', 'tastatur'],
    '🖥️': ['desktop computer', 'desktop-computer'],
    '🖨️': ['printer', 'drucker'],
    '🖱️': ['computer mouse', 'computermaus'],
    '🖲️': ['trackball', 'trackball'],
    '💽': ['computer disk', 'computer-diskette'],
    '💾': ['floppy disk', 'diskette'],
    '💿': ['optical disk', 'optische disk'],
    '📀': ['dvd', 'dvd'],
    '📼': ['videocassette', 'videokassette'],
    '📷': ['camera', 'kamera'],
    '📸': ['camera with flash', 'kamera mit blitz'],
    '📹': ['video camera', 'videokamera'],
    '🎥': ['movie camera', 'film-kamera'],
    '📽️': ['film projector', 'filmprojektor'],
    '🎞️': ['film frames', 'filmstreifen'],
    '📞': ['telephone receiver', 'telefonhörer'],
    '☎️': ['telephone', 'telefon'],
    '📟': ['pager', 'pager'],
    '📠': ['fax machine', 'faxgerät'],
    '📺': ['television', 'fernseher'],
    '📻': ['radio', 'radio'],
    '🎙️': ['studio microphone', 'studiomikrofon'],
    '🎚️': ['level slider', 'pegelregler'],
    '🎛️': ['control knobs', 'steuerknöpfe'],
    '⏱️': ['stopwatch', 'stoppuhr'],
    '⏲️': ['timer clock', 'timeruhr'],
    '⏰': ['alarm clock', 'wecker'],
    '🕰️': ['mantelpiece clock', 'kaminuhr'],
    '⌛': ['hourglass', 'sanduhr'],
    '⏳': ['hourglass with flowing sand', 'sanduhr mit fließendem sand'],
    '📡': ['satellite antenna', 'satellitenantenne'],
    '🔋': ['battery', 'batterie'],
    '🔌': ['electric plug', 'elektrischer stecker'],
    '💡': ['light bulb', 'glühbirne'],
    '🔦': ['flashlight', 'taschenlampe'],
    '🕯️': ['candle', 'kerze'],
    '🪔': ['diya lamp', 'diya-lampe'],
    '💰': ['money bag', 'geldsack'],
    '💴': ['yen banknote', 'yen-banknote'],
    '💵': ['dollar banknote', 'dollar-banknote'],
    '💶': ['euro banknote', 'euro-banknote'],
    '💷': ['pound banknote', 'pfund-banknote'],
    '💸': ['money with wings', 'geld mit flügeln'],
    '💳': ['credit card', 'kreditkarte'],
    '🧾': ['receipt', 'quittung'],
    '💹': ['chart increasing with yen', 'diagramm steigend mit yen'],
    '✉️': ['envelope', 'umschlag'],
    '📧': ['e-mail', 'e-mail'],
    '📨': ['incoming envelope', 'eingehender umschlag'],
    '📩': ['envelope with arrow', 'umschlag mit pfeil'],
    '📤': ['outbox tray', 'ausgangsfach'],
    '📥': ['inbox tray', 'eingangsfach'],
    '📦': ['package', 'paket'],
    '📫': ['closed mailbox with raised flag', 'geschlossener briefkasten mit gehobener flagge'],
    '📪': ['closed mailbox with lowered flag', 'geschlossener briefkasten mit gesenkter flagge']

  };


  filteredEmojis: string[] = [...this.emojis];
  searchTerm: string = '';

  filterEmojis() {
    const lowerSearchTerm = this.searchTerm.toLowerCase();
    this.filteredEmojis = this.emojis.filter(emoji => {
      const keywords = this.emojiDictionary[emoji];
      return keywords && keywords.some(keyword => keyword.includes(lowerSearchTerm));
    });
  }

  selectEmoji(emoji: string) {
    this.emojiSelected.emit(emoji);
  }
}
